import styled from 'styled-components'

export const StyledFormWrapper = styled.div`
  padding-bottom: 40px;
  .short-fields {
    width: 50%;
  }
`
